module.exports = __webpack_public_path__ + "static/media/bullet.ba4003bb.svg";